export const VideoQuestionSummary = [
    {
        result: false,
        text: 'Some indiscreetly including after far unbo Some indiscreetly including after far unbo',
        status: '4'
    },
    {
        result: false,
        text: 'On recommend tolerably my belonging or am. M',
        status: '2'
    },
    {
        result: true,
        text: 'Precarious beyond ouch armadillo as accurat',
        status: '1'
    },
    {
        result: true,
        text: 'Goodness tough much yikes more far pre-set far tough much yikes more far pre-set fa',
        status: '4'
    },
    {
        result: true,
        text: 'Some indiscreetly including after far unbo',
        status: '4'
    },
    {
        result: false,
        text: 'Precarious beyond ouch armadillo as accurat',
        status: '2'
    },
    {
        result: true,
        text: 'Goodness tough much yikes more far pre-set far',
        status: '1'
    },
];


// WEBPACK FOOTER //
// ./src/data/videoQuestionSummary.js